"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f8216 = void 0;
exports.f8216 = {
    "‘vï": [
        1444
    ],
    "‘n’": [
        6544
    ]
};
